import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DenialTypeInfo, DenyDialogOptions } from "./deny-dialog";
import { DenyDialogComponent } from "./deny-dialog.component";


@Injectable()
export class DenyDialogService {

    constructor(private matDialog: MatDialog) {}

    // #region Close All Dialogs Service Call

    CloseAllDialogs(): void {
        this.matDialog.closeAll();
    }

    // #endregion

    // #region Open Deny Dialog Service Call

    Open(options?: DenyDialogOptions): Observable<DenialTypeInfo> {
        const self = this;

        const dlgoptions: MatDialogConfig<any> = {
            disableClose: true,
            data: {
                TitleText: 'Please Wait...',
                MessageText: '',
                OKText: 'Log Out',
                CancelText: 'Stay Logged In',
                DenialTypes: [],
                ...options,
            },
            width: '1000px',
            minWidth: '1000px',
            maxWidth: '1000px',
            height: '22rem',
            minHeight: '22rem',
            maxHeight: '22rem',
        };

        const openHandle = this.matDialog.open<DenyDialogComponent>(DenyDialogComponent, dlgoptions);

        return openHandle.afterClosed();
    }

    // #endregion
}